/**
 * /document-translate — translate a document and get the SAME document back.
 *
 * WHAT THE FIELD ACTUALLY FAILS AT. Every review of the well-known document
 * translators says the same three things, and each has a mechanism:
 *   · "breaks tables and columns" — they rebuild the file instead of editing it;
 *   · "loses formatting" — they extract text and re-typeset it;
 *   · "can't do scanned PDFs" — no text layer, so they stop.
 * The adapters here answer all three by never rebuilding: docx.js, pptx.js,
 * xlsx.js and epub.js swap text nodes inside the original zip, pdf.js deletes
 * the old show operators and draws the translation into the page that was
 * already there, and a page with no text layer is routed to OCR instead of
 * refused.
 *
 * WHAT THIS FILE ADDS ON TOP, and why each earns its place:
 *   · TRANSLATION MEMORY. Contracts and books repeat themselves; identical
 *     paragraphs are translated once. On a real contract that is a third of the
 *     work, and on a book with running headers far more.
 *   · GLOSSARY. Names, codes and trademarks that must survive verbatim, or must
 *     become one specific word. Paid-tier feature everywhere else.
 *   · EDIT BEFORE DOWNLOAD. The translation is shown next to its source and can
 *     be corrected, then rebuilt into the document. A machine translation of a
 *     contract is a draft; a tool that only hands you a file pretends otherwise.
 *   · HONEST DISCLOSURE. Paragraphs that will lose inline emphasis, pages that
 *     had to be OCR'd, runs left at an angle — all counted and shown. Silence
 *     about a compromise is worse than the compromise.
 *
 * The translation itself is TranslatorEngine's provider chain: Chrome's
 * on-device Translator first (no quota, no network, works offline), then the
 * public HTTP providers.
 */
(function () {
    'use strict';

    var CFG = window.__DT_CFG || {};
    var I18N = CFG.i18n || {};
    var slug = 'document-translate';

    function $(id) { return document.getElementById(id); }
    function t(k, f) { return I18N[k] || f || k; }

    // ── «Точный перевод»: серверный лейн (js/translate-server-lane.js) ────
    // С 09.10.2026 он оплачивается ТОКЕНАМИ за объём, всеми (Премиум — со
    // скидкой), а не открыт одному Премиуму: 95 % людей приходят перевести
    // один документ один раз. Цену назначает сервер (DocumentTranslatePricing);
    // страница получает ту же формулу, чтобы назвать цену ДО работы.
    var LANE = (window.__DT_CFG || {}).precise || null;
    function preciseOpen() { return !!(LANE && window.__translateLane); }
    function quality() {
        var r = document.querySelector('input[name="dtQuality"]:checked');
        return (r && r.value === 'precise' && preciseOpen()) ? 'precise' : 'standard';
    }
    function fmtN(n) { try { return Number(n).toLocaleString(window.__intlLocale ? window.__intlLocale() : undefined); } catch (e) { return String(n); } }
    function applySavedQuality() {
        if (!LANE || !window.__toolSettings || state.busy) return;
        var want = window.__toolSettings.load(slug, 'quality', 'standard');
        var r = document.getElementById(want === 'precise' && preciseOpen() ? 'dtQualityPrecise' : 'dtQualityStandard');
        if (r) r.checked = true;
    }

    // Личное — скидка, баланс, вошёл ли — приходит из `precise/info` (no-store):
    // страница тула кэшируется одна на всех.
    var _info = null, _infoAt = 0;
    async function preciseInfo(force) {
        if (!LANE || !LANE.infoUrl) return null;
        if (!force && _info && Date.now() - _infoAt < 30000) return _info;
        try {
            var r = await fetch(LANE.infoUrl, { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } });
            if (r.ok) { _info = await r.json(); _infoAt = Date.now(); }
        } catch (e) { /* без цены страница просто не предложит купить */ }
        return _info;
    }
    /** Знаки так, как их считает сервер (mb_strlen): кодовые точки, не UTF-16. */
    function cps(s) { return Array.from(String(s)).length; }
    /** Цена одной части — та же формула, что DocumentTranslatePricing::tokensFor. */
    function partPrice(chars, price) {
        var base = Math.max(price.min, Math.ceil(chars / 1000) * price.per_1k);
        return Math.max(1, Math.ceil(base * (price.mult || 1)));
    }
    function plural(n, key, fb) {
        var forms = String(t(key, fb)).split('|');
        try {
            var cat = new Intl.PluralRules(window.__intlLocale ? window.__intlLocale() : undefined).select(n);
            var idx = { one: 0, two: 1, few: 1, many: 2, other: forms.length > 2 ? 2 : 1 }[cat];
            return forms[Math.min(idx == null ? forms.length - 1 : idx, forms.length - 1)];
        } catch (e) { return forms[forms.length - 1]; }
    }
    /** «8 250 токенов (≈ 66 ₽)» — рубли только когда курс известен (token-price.js). */
    function tokensText(n) {
        var s = fmtN(n) + ' ' + plural(n, 'tokens_word', 'токен|токена|токенов');
        var m = (window.__tokenPrice && window.__tokenPrice.money) ? window.__tokenPrice.money(n) : '';
        return m ? s + ' (' + m + ')' : s;
    }
    function toast(m, kind) { if (window.__toast) window.__toast(m, kind || 'info'); }
    function ae(f, p) {
        try { if (window.__ae) window.__ae('feature_use', Object.assign({ slug: slug, f: f }, p || {})); }
        catch (e) {}
    }
    var _funnel = {};
    var STAGE_MAP = { file_picked: 'uploading', read: 'reading', translated: 'editing', download: 'complete' };
    function funnel(stage, p) {
        if (_funnel[stage]) return; _funnel[stage] = 1;
        try { if (window.__aeFunnel) window.__aeFunnel(stage, p || {}); } catch (e) {}
        try { if (window.__stage && STAGE_MAP[stage]) window.__stage(STAGE_MAP[stage], { tool: slug }); } catch (e) {}
    }

    var state = {
        file: null, kind: null, doc: null,
        units: [], translated: {}, edited: {},
        // Абзацы, которые обычный лейн перевести не смог (ид → причина): в
        // документе на их месте оригинал, и результат обязан это показать.
        failed: {}, run: null,
        busy: false, abort: null,
        limitTicket: null,
        meta: null, srcLang: 'auto', provider: null,
        stats: null, delivered: false,
        charged: 0,
    };

    // ── lazy libraries ───────────────────────────────────────────────────
    // A .docx reader must not pay for pdf.js, and a PDF reader must not pay for
    // JSZip. Each is fetched the first time a file of that kind arrives.

    var _loaded = {};
    function loadScript(url, globalName) {
        if (window[globalName]) return Promise.resolve(window[globalName]);
        if (_loaded[url]) return _loaded[url];
        _loaded[url] = new Promise(function (res, rej) {
            var s = document.createElement('script');
            s.src = url;
            s.onload = function () {
                if (window[globalName]) res(window[globalName]);
                else rej(new Error('missing global ' + globalName));
            };
            s.onerror = function () { rej(new Error('load_failed ' + url)); };
            document.head.appendChild(s);
        });
        return _loaded[url];
    }
    var _pdfjs = null;
    async function loadPdfJs() {
        if (_pdfjs) return _pdfjs;
        var mod = await import(CFG.pdfjsUrl);
        mod.GlobalWorkerOptions.workerSrc = CFG.pdfjsWorkerUrl;
        _pdfjs = mod;
        return mod;
    }

    // ── which document is this ───────────────────────────────────────────

    /**
     * Extension is a hint, not an answer: a .docx renamed from .zip, a PDF
     * saved as .txt and an EPUB with no extension all arrive in real life. The
     * first bytes settle it, and only then does the name break a tie between
     * the two zip formats.
     */
    async function sniff(file) {
        var head = new Uint8Array(await file.slice(0, 8).arrayBuffer());
        var isZip = head[0] === 0x50 && head[1] === 0x4b;
        var isPdf = head[0] === 0x25 && head[1] === 0x50 && head[2] === 0x44 && head[3] === 0x46;
        if (isPdf) return 'pdf';
        if (!isZip) {
            if (/\.pdf$/i.test(file.name)) return 'pdf';
            return null;
        }
        var JSZip = await loadScript(CFG.jszipUrl, 'JSZip');
        var zip = await JSZip.loadAsync(file);
        // Each OPC family has one part that only it has, so the answer comes
        // from the archive rather than from a name anyone can mistype.
        if (zip.file('word/document.xml')) return 'docx';
        if (zip.file('ppt/presentation.xml')) return 'pptx';
        if (zip.file('xl/workbook.xml')) return 'xlsx';
        if (zip.file('META-INF/container.xml')) return 'epub';
        if (Object.keys(zip.files).some(function (n) { return /\.opf$/i.test(n); })) return 'epub';
        return null;
    }

    // ── reading ──────────────────────────────────────────────────────────

    async function readDocument(file) {
        var kind = await sniff(file);
        if (!kind) throw new Error('unsupported');
        state.kind = kind;

        // Every OPC/EPUB family needs the same reader and nothing else; the
        // heavy PDF stack below is fetched only when a PDF actually arrives.
        var ZIP_ADAPTERS = { docx: 'DTDocx', pptx: 'DTPptx', xlsx: 'DTXlsx', epub: 'DTEpub' };
        if (ZIP_ADAPTERS[kind]) {
            var JSZip = await loadScript(CFG.jszipUrl, 'JSZip');
            var adapter = window[ZIP_ADAPTERS[kind]];
            if (!adapter) throw new Error('engine_missing');
            return adapter.open(file, JSZip);
        }

        var pdfjsLib = await loadPdfJs();
        var PDFLib = await loadScript(CFG.pdfLibUrl, 'PDFLib');
        await window.PdfTextFont.load();
        var ocrPage = makeOcrPage();
        try {
            return await window.DTPdf.open(await unlockedPdf(file), {
                pdfjsLib: pdfjsLib,
                PDFLib: PDFLib,
                PdfTextFont: window.PdfTextFont,
                PdfTextErase: window.PdfTextErase,
                ocrPage: ocrPage,
                onProgress: function (p) {
                    setProgress(t('phase_read', 'Чтение') + ' ' + p.page + '/' + p.pages, p.page / p.pages);
                },
            });
        } finally {
            // The recogniser's memory (its worker's wasm heap, the model) is
            // returned only by closing it — and nothing reads after this point.
            // Until 23.10.2026 it lived until the tab closed, right through the
            // build, where pdf-lib parses the whole file again.
            if (ocrPage && ocrPage.close) ocrPage.close();
        }
    }

    /**
     * PDF с защитой — сначала снять её, потом читать.
     *
     * ⚠️⚠️ До 14.10.2026 защищённый PDF (запрет копирования или печати — так
     * выходят книги, стандарты, выписки, инструкции) проходил весь путь:
     * pdf.js читает его текст, перевод идёт, а собирает документ pdf-lib,
     * который шифрование не понимает (`ignoreEncryption`). Исход был один из
     * двух, оба плохие и оба воспроизведены. Объекты в сжатых объектных
     * потоках — «Не удалось собрать документ» ПОСЛЕ всего перевода: pdf-lib
     * не находит зашифрованные объекты («Expected instance of e, but got
     * instance of undefined» — 146 раз за 30 дней). Без объектных потоков —
     * хуже: файл «с переводом», в котором читалка видит прежний текст. Наши
     * страницы записаны открыто, а трейлер по-прежнему объявляет шифрование,
     * и читалка «расшифровывает» их в мусор; чужой читатель (pypdf) извлекает
     * из такого файла исходный текст, нового в нём нет.
     *
     * qpdf снимает защиту без потерь (тот же воркер, что у «Снять пароль с
     * PDF»); пароль на ОТКРЫТИЕ он без пароля не снимет — тогда отказ словами
     * и до работы, а не после неё.
     */
    function hasEncryptKey(bytes) {
        // «/Encrypt» стоит в словаре трейлера или xref-потока; сами словари не
        // шифруются и не сжимаются, так что ключ виден в байтах файла. Ложное
        // совпадение стоит одного лишнего прохода qpdf, пропуск — документа.
        var pat = [0x2f, 0x45, 0x6e, 0x63, 0x72, 0x79, 0x70, 0x74];
        outer: for (var i = bytes.length - pat.length; i >= 0; i--) {
            for (var k = 0; k < pat.length; k++) if (bytes[i + k] !== pat[k]) continue outer;
            return true;
        }
        return false;
    }
    function qpdfDecrypt(bytes, name) {
        return new Promise(function (resolve, reject) {
            var w, timer;
            function done(err, out) {
                clearTimeout(timer);
                try { w.terminate(); } catch (e) {}
                if (err) reject(err); else resolve(out);
            }
            try { w = new Worker(CFG.unlockWorkerUrl); }
            catch (e) { reject(new Error('pdf_locked: no worker')); return; }
            timer = setTimeout(function () { done(new Error('pdf_locked: timeout')); }, 120000);
            w.onmessage = function (ev) {
                var m = ev.data || {};
                if (m.type === 'done') done(null, new Uint8Array(m.bytes));
                else if (m.type === 'error') {
                    var why = String(m.msg || '');
                    done(new Error((why.indexOf('WRONG_PASSWORD') === 0 ? 'pdf_password: ' : 'pdf_locked: ') + why.slice(0, 120)));
                }
            };
            w.onerror = function (e) { done(new Error('pdf_locked: worker ' + String((e && e.message) || '').slice(0, 80))); };
            var copy = bytes.slice(0);
            w.postMessage({ type: 'decrypt', file: { bytes: copy.buffer, name: name }, password: '', opts: { outputName: name } }, [copy.buffer]);
        });
    }
    async function unlockedPdf(file) {
        var bytes = new Uint8Array(await file.arrayBuffer());
        if (!hasEncryptKey(bytes)) return bytes;
        if (!CFG.unlockWorkerUrl) throw new Error('pdf_locked: no worker url');
        var t0 = Date.now();
        try {
            var out = await qpdfDecrypt(bytes, file.name || 'document.pdf');
            ae('pdf_unlocked', { ms: Date.now() - t0, kb: Math.round(bytes.length / 1024) });
            return out;
        } catch (e) {
            ae('pdf_locked', { why: String((e && e.message) || e).slice(0, 60) });
            throw e;
        }
    }

    /**
     * A scanned page is routed to the neural recogniser rather than refused.
     * Measured on /pdf-to-word: 6 of its 8 errors over 30 days are literally
     * "this PDF has no text", and 7 of its 10 abandons sit on that screen — the
     * tool's advice is to go and find OCR somewhere else.
     */
    function makeOcrPage() {
        if (!window.PPOCR) return null;
        var engine = null, engineLang = null;
        var read = async function (canvas, pageIndex) {
            // The recogniser is per SCRIPT, and 'auto' has no script. A Latin
            // model asked to read Cyrillic returns confident Latin nonsense —
            // «АПТЕКА» comes back as «ANTEKA» — so the language the visitor
            // chose is what decides, and 'auto' falls back to the site locale's
            // script rather than to a guess about the pixels.
            var lang = state.srcLang && state.srcLang !== 'auto'
                ? state.srcLang : (CFG.locale || 'en');
            if (!engine || engineLang !== lang) {
                setProgress(t('phase_download', 'Загрузка модели распознавания'), null);
                engine = await window.PPOCR.open(lang, {
                    workerUrl: CFG.ocrWorkerUrl || undefined,
                    onProgress: function (f) {
                        setProgress(t('phase_download', 'Загрузка модели распознавания'), f);
                    },
                });
                engineLang = lang;
                ae('ocr_engine_ready', { lang: lang, provider: engine.provider });
            }
            setProgress(t('phase_ocr', 'Распознавание страницы') + ' ' + (pageIndex + 1), null);
            // read() ПЕРЕДАЁТ первый аргумент воркеру владением, а canvas не
            // передаётся: postMessage бросил бы DataCloneError, и распознавание
            // сканов падало бы на первой же странице. Нужен ImageBitmap.
            var bmp = await createImageBitmap(canvas);
            var res = await engine.read(bmp, {});
            return (res.lines || []).map(function (l) { return { text: l.text, box: l.box }; });
        };
        read.close = function () {
            if (engine) { try { engine.close(); } catch (e) { /* already gone */ } }
            engine = null; engineLang = null;
        };
        return read;
    }

    // ── glossary ─────────────────────────────────────────────────────────

    /**
     * Terms the translator must not touch, or must render one specific way.
     *
     * The mechanism is TranslatorEngine's own tag protection: `{0}` is a tag to
     * it, so it travels through every provider untouched and comes back in
     * place. The cost is real and is stated in the UI rather than hidden — a
     * protected term splits its sentence, so the two halves are translated
     * without each other's context. That is the right trade for a name or a
     * part number and the wrong one for an ordinary word.
     */
    function parseGlossary(raw) {
        var out = [];
        String(raw || '').split(/\r?\n/).forEach(function (line) {
            var s = line.trim();
            if (!s) return;
            var m = s.split(/\s*(?:=>|→|=)\s*/);
            var from = (m[0] || '').trim();
            if (!from) return;
            out.push({ from: from, to: m.length > 1 ? (m[1] || '').trim() : from });
        });
        // Longest first: "Acme Corp" must win over "Acme".
        return out.sort(function (a, b) { return b.from.length - a.from.length; });
    }

    function protectTerms(text, glossary) {
        if (!glossary.length) return { text: text, map: null };
        var map = [], out = text;
        glossary.forEach(function (g) {
            var re = new RegExp(g.from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
            out = out.replace(re, function () {
                map.push(g.to);
                return '{' + (map.length - 1) + '}';
            });
        });
        return { text: out, map: map };
    }

    function restoreTerms(text, map) {
        if (!map) return text;
        return String(text).replace(/\{(\d+)\}/g, function (whole, i) {
            var v = map[+i];
            return v === undefined ? whole : v;
        });
    }

    // ── translating ──────────────────────────────────────────────────────

    /**
     * Translation memory. A contract repeats its own clauses and a book its
     * running heads; translating the same string twice costs the visitor quota
     * (and, in the precise lane, tokens) and the provider goodwill for nothing.
     */
    function buildJobs() {
        var unique = {}, order = [];
        state.units.forEach(function (u) {
            var key = u.text.trim();
            if (!unique[key]) { unique[key] = { text: key, ids: [] }; order.push(key); }
            unique[key].ids.push(u.id);
        });
        return order.map(function (k) { return unique[k]; });
    }

    /**
     * What a precise run sends and what it costs, BEFORE it runs: the same
     * split into parts the run uses, priced part by part with the server's
     * formula on the very text the server will count (terms already masked).
     */
    function precisePlan(jobs, glossary) {
        var send = [], rest = [];
        jobs.forEach(function (job) {
            if (job.text.length > LANE.unitMax) rest.push(job); else send.push(job);
        });
        var parts = send.length ? planParts(send) : [];
        var price = (_info && _info.price) || LANE.price;
        var chars = 0, tokens = 0;
        parts.forEach(function (part) {
            var c = part.reduce(function (s, job) { return s + cps(protectTerms(job.text, glossary).text); }, 0);
            chars += c;
            tokens += partPrice(c, price);
        });
        // Длиннее восьми частей точный режим документ не берёт (translatePrecise
        // отдаёт его обычному лейну целиком) — цену такому не называем.
        var tooLong = parts.length > (LANE.maxParts || 8);
        return { send: tooLong ? [] : send, rest: tooLong ? jobs : rest, parts: tooLong ? [] : parts, nParts: parts.length, chars: chars, tokens: tooLong ? 0 : tokens, tooLong: tooLong };
    }

    async function translateAll(mode, how) {
        var TE = window.TranslatorEngine;
        if (!TE || typeof TE.translateTexts !== 'function') throw new Error('engine_missing');

        var src = $('dtSrc') ? $('dtSrc').value : 'auto';
        var tgt = $('dtTgt') ? $('dtTgt').value : 'en';
        state.srcLang = src;
        var glossary = parseGlossary($('dtGlossary') ? $('dtGlossary').value : '');

        var jobs = buildJobs();
        var saved = state.units.length - jobs.length;
        if (saved > 0) ae('memory_hit', { saved: saved, total: state.units.length });

        state.abort = new AbortController();
        state.preciseNotes = [];
        state.charged = 0;
        var again = !!(how && how.again);
        if (!again) state.provider = null;
        var rest = jobs;
        if (mode === 'precise' && LANE && window.__translateLane) {
            rest = (await translatePrecise(jobs, src, tgt, glossary)).rest;
            // Повтор «точнее» поверх готового перевода: чего модель не взяла,
            // уже переведено обычным лейном в первый раз — второй проход лишний.
            if (again) rest = [];
        }
        var failed = rest.length ? await translateStandard(rest, src, tgt, glossary, TE) : 0;
        return { unique: jobs.length, saved: saved, failed: failed };
    }

    /**
     * Обычный лейн: весь документ уходит движку РАЗОМ (TranslatorEngine.
     * translateTexts), а тот шлёт абзацы пачками — до тысячи в одном запросе.
     *
     * ⚠️⚠️ До 13.10.2026 здесь был запрос на абзац, по четыре разом. Замер на
     * живом эндпоинте из настоящего браузера: ~285 мс на абзац, а после ~1200
     * запросов Google перестаёт отвечать адресу вовсе (отказ без CORS-заголовка,
     * страница видит «Failed to fetch»), и остаток достаётся MyMemory с его
     * 5–50 тыс. знаков в сутки. Телеметрия за 30 дней говорила то же с другой
     * стороны: документы от 1000 абзацев (треть всех) — 6,5 мин по медиане и
     * 86 мин на p90, 30 % не дожидались, а 15 % ВСЕХ прогонов отдавали
     * документ с непереведёнными абзацами. Пачкой тот же документ — секунды,
     * и перевод слово в слово тот же (300 из 300). Разбор —
     * docs/why/primitives/translate-texts.md.
     *
     * Возвращает число абзацев (уникальных), которые перевести не удалось; сами
     * они помечены в `state.failed` и остаются в документе на языке оригинала.
     */
    async function translateStandard(jobs, src, tgt, glossary, TE) {
        var prot = jobs.map(function (job) { return protectTerms(job.text, glossary); });
        var stats = {};
        var t0 = Date.now();
        var label = t('phase_translate', 'Перевод');
        setProgress(label, null);
        // Пока движок ЖДЁТ (сервис отказал, повтор через секунды), экран говорит
        // это словами: остановившаяся полоса без объяснения и есть «зависло».
        var frac = null, waiting = false;
        function paint() {
            if (waiting) setProgress(t('phase_retry', 'Сервис перевода не отвечает — пробуем ещё раз…'), null);
            else setProgress(frac == null ? label : label + ' · ' + Math.round(frac * 100) + ' %', frac);
        }
        var res = await TE.translateTexts(prot.map(function (x) { return x.text; }), src, tgt, state.abort.signal, {
            _stats: stats,
            onProgress: function (p) { frac = p.frac; paint(); },
            onStatus: function (st) { waiting = st.state === 'retrying'; paint(); },
        });
        var failed = 0;
        jobs.forEach(function (job, i) {
            // translateTexts отдаёт ОБЪЕКТ на каждый текст; `reason` значит, что
            // `text` — оригинал, и выдавать его за перевод нельзя.
            var r = res[i] || { reason: 'unknown' };
            var bad = !!r.reason;
            if (r.provider && state.provider !== 'precise' && (!bad || !state.provider)) state.provider = r.provider;
            var out = bad ? job.text : restoreTerms(r.text || '', prot[i].map);
            job.ids.forEach(function (id) {
                state.translated[id] = out;
                if (bad) state.failed[id] = r.reason; else delete state.failed[id];
            });
            if (bad) failed++;
        });
        state.run = {
            lane: stats.lane || '', req: stats.requests || 0, retries: stats.retries || 0,
            fb: stats.fallbackTexts || 0, ms: Date.now() - t0,
        };
        return failed;
    }

    /**
     * Разложить абзацы по прогонам лейна.
     *
     * ⚠️⚠️ До 19.09.2026 этого не было вовсе: документ длиннее `maxChars`
     * получал отказ целиком и переводился обычным способом. То есть платная
     * возможность отказывала ровно на том, за что её покупают, — на договоре
     * в сорок страниц; потолок 40 000 знаков — это около тринадцати страниц
     * плотного текста. Теперь документ уходит ЧАСТЯМИ, и часть — это один
     * прогон серверной лестницы (`server_runs`), поэтому число частей названо
     * человеку до начала работы, а не подсчитано им по счётчику.
     *
     * Граница части проходит МЕЖДУ абзацами и в порядке документа: модель
     * видит соседей внутри части, а глоссарий передаётся каждой из них, так
     * что единая терминология переживает границу.
     */
    function planParts(jobs) {
        var parts = [], cur = [], chars = 0;
        jobs.forEach(function (job) {
            var len = job.text.length;
            if (cur.length && (chars + len > LANE.maxChars || cur.length >= LANE.maxUnits)) {
                parts.push(cur); cur = []; chars = 0;
            }
            cur.push(job);
            chars += len;
        });
        if (cur.length) parts.push(cur);
        return parts;
    }

    /** Обращение и стиль документа — их читает только модель. */
    function preciseStyle() {
        var f = $('dtFormality') ? $('dtFormality').value : 'auto';
        var d = $('dtDomain') ? $('dtDomain').value : '';
        var out = {};
        if (f && f !== 'auto') out.formality = f;
        if (d) out.domain = d;
        return out;
    }

    /**
     * «Точный перевод»: документ уходит модели ПАКЕТАМИ ПОДРЯД, а не абзац за
     * абзацем — это и есть разница в качестве. Центральный гейт списывает
     * единицу за POST, поэтому один POST несёт столько абзацев, сколько
     * помещается в бюджет края, а длинный документ разбивается на несколько
     * частей (см. planParts). Возвращает то, что осталось обычному лейну
     * (отказ, провал модели, заведомо неподъёмные куски) — недопереведённым
     * документ не остаётся ни при каком исходе.
     */
    async function translatePrecise(jobs, src, tgt, glossary) {
        var send = [], rest = [], total = 0;
        jobs.forEach(function (job) {
            if (job.text.length > LANE.unitMax) rest.push(job);
            else { send.push(job); total += job.text.length; }
        });
        if (!send.length) return { rest: jobs };

        var parts = planParts(send);
        var maxParts = LANE.maxParts || 8;
        if (parts.length > maxParts) {
            // Решено ДО запроса и с числами: иначе человек ждал бы ответа,
            // чтобы узнать то, что известно уже сейчас.
            state.preciseNotes.push(
                t('precise_too_long', '')
                    .split(':chars').join(fmtN(total))
                    .split(':max').join(fmtN(LANE.maxChars * maxParts))
            );
            ae('precise_refused', { reason: 'too_long', chars: total, units: send.length, parts: parts.length });
            return { rest: jobs };
        }

        var terms = glossary.map(function (g) { return g.to; }).filter(Boolean);
        var style = preciseStyle();
        var t0 = Date.now();
        var label = t('precise_phase', 'Точный перевод всего документа');
        var partNo = 0;
        function labelNow() {
            if (parts.length < 2) return label;
            return t('precise_part', 'Точный перевод — часть :i из :n')
                .split(':i').join(partNo).split(':n').join(parts.length);
        }
        // Один синхронный запрос длиной до пары минут: без часов он неотличим
        // от зависания.
        var tick = setInterval(function () {
            var s = Math.round((Date.now() - t0) / 1000);
            setProgress(labelNow() + ' · ' + Math.floor(s / 60) + ':' + ('0' + (s % 60)).slice(-2), null);
        }, 1000);
        funnel('precise_start', { units: send.length, chars: total, parts: parts.length, style: style.domain || '', formality: style.formality || '' });

        var got = 0;
        try {
            for (var p = 0; p < parts.length; p++) {
                partNo = p + 1;
                setProgress(labelNow(), null);
                var batch = parts[p];
                var prot = batch.map(function (job) { return protectTerms(job.text, glossary); });
                var res;
                try {
                    res = await window.__translateLane.translate({
                        serverUrl: LANE.serverUrl,
                        // Ответ на часть не дошёл — забрать её по ключу, а не
                        // переводить и оплачивать заново (PaidOrder).
                        statusUrl: LANE.statusUrl,
                        texts: prot.map(function (x) { return x.text; }),
                        src: src, tgt: tgt, terms: terms, style: style,
                        signal: state.abort.signal,
                    });
                } catch (e) {
                    if (e && e.name === 'AbortError') throw e;
                    // Отказ на второй части — это не «ничего не вышло»: первая
                    // уже переведена моделью и остаётся. Остаток честно уходит
                    // обычному лейну, и об этом сказано.
                    if (e && e.tokens) {
                        // Кошелёк отказал посреди документа (токены ушли на
                        // другое, «заняты своим же переводом») — словами кошелька.
                        state.preciseNotes.push(e.tokens.msg || t('precise_tokens_out', 'Токенов не хватило на весь документ — остаток переведён обычным способом'));
                    } else {
                        // 429 (сутки кончились), 413, 503 — у сервера своя
                        // фраза, она точнее нашей; следом — что стало с
                        // документом.
                        if (e && e.message && e.status !== 502) state.preciseNotes.push(e.message);
                        // «Не получился» — только если моделью не переведено
                        // ничего; иначе это неправда о первой части, а остаток
                        // назовёт строка «переведено обычным способом: N».
                        if (!got) state.preciseNotes.push(t('precise_fallback', 'Точный перевод не получился — документ переведён обычным способом'));
                    }
                    ae('precise_refused', { status: e ? e.status : 0, part: partNo, of: parts.length, tokens: e && e.tokens ? 1 : 0 });
                    for (var q = p; q < parts.length; q++) rest = rest.concat(parts[q]);
                    break;
                }
                state.charged += res.charged || 0;
                if (res.balance != null && _info) _info.balance = res.balance;
                var bad = {};
                res.failed.forEach(function (i) { bad[i] = true; });
                /* eslint-disable no-loop-func */
                batch.forEach(function (job, i) {
                    if (bad[i]) { rest.push(job); return; }
                    var out = restoreTerms(res.texts[i], prot[i].map);
                    job.ids.forEach(function (id) { state.translated[id] = out; delete state.failed[id]; });
                    got++;
                });
                /* eslint-enable no-loop-func */
            }
            if (got) { state.provider = 'precise'; dropPending(); }
            if (rest.length) state.preciseNotes.push(t('precise_partial', '').split(':n').join(fmtN(rest.length)));
            if (state.charged) state.preciseNotes.push(t('precise_charged', 'Точный перевод: списано :tokens').split(':tokens').join(tokensText(state.charged)));
            funnel('precise_done', {
                units: send.length, got: got, rest: rest.length, charged: state.charged,
                parts: parts.length, s: Math.round((Date.now() - t0) / 1000),
            });
            return { rest: rest };
        } finally {
            clearInterval(tick);
        }
    }

    function renderPreciseNotes() {
        var box = $('dtNotes');
        if (box && state.preciseNotes && state.preciseNotes.length) {
            state.preciseNotes.forEach(function (m) {
                var p = document.createElement('p');
                p.className = 'dt-note';
                p.textContent = m;
                box.appendChild(p);
            });
            box.hidden = false;
        }
        var note = $('dtPreciseNote');
        if (note) { note.hidden = true; note.textContent = ''; }
        var btn = $('dtPrecise');
        if (btn) {
            btn.hidden = !preciseOpen() || state.provider === 'precise';
            // Цена — на самой кнопке, как у озвучки сверх суток: нажатие с
            // названной ценой и есть согласие.
            if (!btn.hidden) {
                var plan = precisePlan(buildJobs(), currentGlossary());
                btn.hidden = !plan.send.length;
                btn.textContent = t('precise_again_price', 'Перевести точнее · :price').split(':price').join(fmtN(plan.tokens) + ' ' + plural(plan.tokens, 'tokens_word', 'токен|токена|токенов'));
            }
        }
    }

    function currentGlossary() { return parseGlossary($('dtGlossary') ? $('dtGlossary').value : ''); }

    /**
     * Цена документа ДО работы и решение человека: 'go' | 'standard' | 'cancel'.
     *
     * Хватает токенов — «Перевести точно · N». Не хватает или не вошёл —
     * «Купить токены» (стена token-wall.js: пакет, гостю аккаунт после оплаты),
     * а документ с готовой работой уходит в хранилище работы: касса уводит со
     * страницы (у гостя — вход по ссылке возврата, у вошедшего — перезагрузка),
     * и без этого человек возвращался бы к пустому тулу. Обычный перевод
     * остаётся рядом всегда, кроме случая, когда на сегодня его уже нет.
     */
    async function preciseOffer(plan, opts) {
        opts = opts || {};
        var box = $('dtOffer');
        if (!box) return 'go';
        // `opts.failed` — обычный лейн не перевёл НИЧЕГО (сервис перевода не
        // отвечает этому адресу). Выдать такой документ за результат нельзя;
        // честный выход — повторить или перевести точно, с ценой. Точного
        // лейна может и не быть (выключен, документ ему не по размеру) — тогда
        // в панели остаётся одно «Повторить».
        var can = !!(plan && plan.send.length && preciseOpen());
        var info = can ? await preciseInfo(true) : null;
        if (can && window.__tokenPrice && window.__tokenPrice.ready) {
            try { await window.__tokenPrice.ready(); } catch (e) { /* рубли не обязательны */ }
        }
        if (can && info && info.price) plan = precisePlan(plan.send.concat(plan.rest), currentGlossary());
        var need = can ? plan.tokens : 0;
        var guest = !info || !info.logged_in;
        var bal = info ? (info.balance | 0) : 0;
        var enough = can && !guest && bal >= need;
        var pageChars = (info && info.price && info.price.page_chars) || (LANE && LANE.price && LANE.price.page_chars) || 1800;
        var pages = can ? Math.max(1, Math.round(plan.chars / pageChars)) : 0;

        var lead = opts.capped ? t('precise_capped', '')
            : opts.failed ? t('std_failed', 'Обычный перевод сейчас не отвечает — документ остался без перевода.') : '';
        $('dtOfferMsg').textContent = (lead ? lead + ' ' : '') + (!can ? '' : t('precise_offer', 'Точный перевод этого документа: :pages стр. (:chars знаков) — :price.')
            .split(':pages').join(fmtN(pages)).split(':chars').join(fmtN(plan.chars)).split(':price').join(tokensText(need)));
        $('dtOfferSub').textContent = !can ? ''
            : guest ? t('precise_guest', '')
            : enough ? t('precise_balance_ok', 'На балансе :balance.').split(':balance').join(tokensText(bal))
            : t('precise_balance_short', 'На балансе :balance — не хватает :short.').split(':balance').join(fmtN(bal)).split(':short').join(tokensText(need - bal));
        var gain = box.querySelector('.dt-offer-gain');
        if (gain) gain.hidden = !can;
        var go = $('dtOfferGo'), buy = $('dtOfferBuy'), std = $('dtOfferStd'), cancel = $('dtCancel');
        go.hidden = !enough;
        go.textContent = t('precise_go', 'Перевести точно') + ' · ' + fmtN(need);
        var storeUrl = info && info.store_url;
        buy.hidden = !can || enough || !storeUrl;
        if (storeUrl) buy.setAttribute('href', storeUrl);
        buy.setAttribute('data-tmb-short', String(guest ? need : Math.max(1, need - bal)));
        buy.setAttribute('data-tmb-title', t('precise_buy_title', 'Токены для точного перевода'));
        std.hidden = !!opts.capped;
        std.textContent = opts.failed ? t('std_retry', 'Повторить')
            : opts.again ? t('precise_keep', 'Оставить обычный перевод') : t('precise_std', 'Перевести обычным');

        var phase = $('dtPhase'), track = document.querySelector('#dtWork .dt-track');
        box.hidden = false;
        if (phase) phase.hidden = true;
        if (track) track.hidden = true;
        ae('precise_offer', { chars: can ? plan.chars : 0, tokens: need, enough: enough ? 1 : 0, guest: guest ? 1 : 0, capped: opts.capped ? 1 : 0, again: opts.again ? 1 : 0, failed: opts.failed ? 1 : 0, can: can ? 1 : 0 });

        var chosen = await new Promise(function (resolve) {
            function done(v) {
                go.removeEventListener('click', onGo);
                std.removeEventListener('click', onStd);
                buy.removeEventListener('click', onBuy);
                if (cancel) cancel.removeEventListener('click', onCancel);
                resolve(v);
            }
            function onGo() { done('go'); }
            function onStd() { done('standard'); }
            function onCancel() { done('cancel'); }
            // Стена открывается тем же нажатием; решение остаётся за кассой, а
            // документ — в хранилище работы до возвращения.
            function onBuy() { stashPending(opts.again ? 'result' : 'offer'); ae('precise_offer_buy', { short: need - bal, guest: guest ? 1 : 0 }); }
            go.addEventListener('click', onGo);
            std.addEventListener('click', onStd);
            buy.addEventListener('click', onBuy);
            if (cancel) cancel.addEventListener('click', onCancel);
        });
        box.hidden = true;
        if (phase) phase.hidden = false;
        if (track) track.hidden = false;
        ae('precise_offer_' + chosen, { tokens: need });
        return chosen;
    }

    // ── документ, ждущий оплаты (хранилище работы) ───────────────────────
    // Не localStorage: документ весит мегабайты. Хранилище — __toolDraft
    // (work-storage.js + tool-draft.js), один слот «pending», двое суток.
    var _drafts = null;
    function draftStore() {
        if (_drafts !== null) return _drafts;
        _drafts = false;
        try {
            if (window.__toolDraft) _drafts = window.__toolDraft.store(slug, { maxDrafts: 2, maxAgeMs: 2 * 864e5, debounceMs: 0 });
        } catch (e) { _drafts = false; }
        return _drafts;
    }
    function val(id) { var el = $(id); return el ? el.value : ''; }
    function unitsSig() {
        return state.units.length + ':' + state.units.reduce(function (s, u) { return s + u.text.length; }, 0);
    }
    function stashPending(stage) {
        var S = draftStore();
        if (!S || !state.file) return;
        try {
            S.save('pending', {
                label: state.file.name,
                files: [state.file],
                state: {
                    v: 1, stage: stage, name: state.file.name, sig: unitsSig(),
                    src: val('dtSrc'), tgt: val('dtTgt'), glossary: val('dtGlossary'),
                    formality: val('dtFormality'), domain: val('dtDomain'),
                    bilingual: !!($('dtBilingual') && $('dtBilingual').checked),
                    translated: stage === 'result' ? state.translated : null,
                    edited: stage === 'result' ? state.edited : null,
                },
            });
        } catch (e) { /* без хранилища документ просто придётся выбрать снова */ }
    }
    function dropPending() {
        var S = draftStore();
        if (S) { try { S.remove('pending'); } catch (e) {} }
    }
    async function offerResume() {
        var S = draftStore();
        var box = $('dtResume');
        if (!S || !box) return;
        var d = null;
        try { d = await S.load('pending'); } catch (e) { d = null; }
        if (!d || !d.state || !d.files || !d.files[0] || state.busy || state.units.length) return;
        $('dtResumeMsg').textContent = t('resume_msg', 'Документ «:name» ждёт точного перевода.').split(':name').join(d.state.name || d.files[0].name || '');
        box.hidden = false;
        ae('precise_resume_shown', { stage: d.state.stage });
        $('dtResumeGo').onclick = function () {
            box.hidden = true;
            ae('precise_resume_used', { stage: d.state.stage });
            var s = d.state;
            [['dtSrc', s.src], ['dtTgt', s.tgt], ['dtGlossary', s.glossary], ['dtFormality', s.formality], ['dtDomain', s.domain]].forEach(function (p) {
                var el = $(p[0]);
                if (el && p[1] != null && p[1] !== '') el.value = p[1];
            });
            if ($('dtBilingual')) $('dtBilingual').checked = !!s.bilingual;
            var pr = $('dtQualityPrecise');
            if (pr) pr.checked = true;
            var up = $('dtUpload');
            if (up && typeof up.__uploaderCollapse === 'function') { try { up.__uploaderCollapse([d.files[0]]); } catch (e) {} }
            accept(d.files[0], { resume: s });
        };
        $('dtResumeNo').onclick = function () {
            box.hidden = true;
            ae('precise_resume_dropped', {});
            dropPending();
        };
    }

    /** «Перевести точнее» поверх готового результата — без повторного чтения файла. */
    async function translateAgainPrecisely() {
        if (state.busy || !state.units.length || !preciseOpen()) return;
        state.busy = true;
        show('dtWork');
        try {
            var plan = precisePlan(buildJobs(), currentGlossary());
            if (!plan.send.length || (await preciseOffer(plan, { again: true })) !== 'go') return;
            var res = await translateAll('precise', { again: true });
            funnel('translated', {
                unique: res.unique, saved: res.saved, failed: res.failed,
                provider: state.provider || 'unknown', mode: 'precise', again: 1,
            });
            renderNotes();
            renderPairs();
            fillSummary(res);
            var dl = $('dtDownload');
            if (dl) dl.classList.add('dt-restale');
        } catch (e) {
            if (e && e.name === 'AbortError') toast(t('cancelled', 'Отменено'), 'info');
            else toast(t('precise_fallback', 'Точный перевод не получился'), 'warning');
        } finally {
            show('dtResult');
            state.busy = false;
        }
    }

    // ── абзацы, которые обычный лейн не перевёл ──────────────────────────
    function isUntranslated(id) { return !!state.failed[id] && state.edited[id] === undefined; }
    function failedJobs() {
        return buildJobs().filter(function (job) { return job.ids.some(isUntranslated); });
    }
    function failedCount() {
        var n = 0;
        state.units.forEach(function (u) { if (isUntranslated(u.id)) n++; });
        return n;
    }

    /**
     * Сказать, сколько абзацев осталось на языке оригинала, и дать перевести
     * их ещё раз. До 13.10.2026 об этом сообщал один тост («часть абзацев
     * перевести не удалось»), который исчезал раньше, чем человек открывал
     * скачанный файл; какие это абзацы и сколько их — не было видно нигде, а
     * повторить можно было только весь документ, выбрав его заново.
     */
    function renderFailed() {
        var n = failedCount();
        var note = $('dtUntr');
        if (note) {
            note.hidden = !n;
            note.textContent = n ? t('note_untranslated', 'Не переведено абзацев: :n из :total — сервис перевода не ответил. В документе они остались на языке оригинала.')
                .split(':n').join(fmtN(n)).split(':total').join(fmtN(state.units.length)) : '';
        }
        var btn = $('dtRetry');
        if (btn) btn.hidden = !n;
    }

    function renderNotes() {
        renderDisclosures(state.meta);
        renderPreciseNotes();
        renderFailed();
    }

    /** «Перевести оставшиеся»: только непереведённые абзацы, без нового чтения файла. */
    async function retryFailed() {
        var TE = window.TranslatorEngine;
        var jobs = failedJobs();
        if (state.busy || !jobs.length || !TE) return;
        state.busy = true;
        show('dtWork');
        try {
            state.abort = new AbortController();
            var failed = await translateStandard(jobs, state.srcLang, val('dtTgt'), currentGlossary(), TE);
            ae('retry_rest', Object.assign({ asked: jobs.length, failed: failed }, state.run || {}));
            if (failed >= jobs.length) toast(t('std_failed', 'Обычный перевод сейчас не отвечает'), 'warning');
            renderNotes();
            renderPairs();
            var dl = $('dtDownload');
            if (dl && failed < jobs.length) dl.classList.add('dt-restale');
        } catch (e) {
            if (e && e.name === 'AbortError') toast(t('cancelled', 'Отменено'), 'info');
            else toast(t('err_generic', 'Не удалось обработать документ'), 'error');
        } finally {
            show('dtResult');
            state.busy = false;
        }
    }

    // ── building ─────────────────────────────────────────────────────────

    async function buildOutput() {
        var merged = {};
        state.units.forEach(function (u) {
            var v = state.edited[u.id] !== undefined ? state.edited[u.id] : state.translated[u.id];
            if (v !== undefined) merged[u.id] = v;
        });

        var opts = {};
        if (state.kind === 'pdf') {
            opts.bilingual = !!($('dtBilingual') && $('dtBilingual').checked);
        }
        if (state.kind === 'epub') {
            opts.lang = $('dtTgt') ? $('dtTgt').value : undefined;
        }
        var res = await state.doc.build(merged, opts);
        // The PDF adapter reports what it had to do; the zip adapters return a
        // Blob directly.
        if (res && res.blob) { state.stats = res.stats; return res.blob; }
        return res;
    }

    function outName() {
        var base = (state.file && state.file.name) || 'document';
        var dot = base.lastIndexOf('.');
        var stem = dot > 0 ? base.slice(0, dot) : base;
        // The extension is the FORMAT WE WROTE, never the one that arrived: a
        // deck saved as .ppt and read as OPC must come back as .pptx, or the
        // file the visitor gets is one their own Office refuses to open.
        var ext = { docx: 'docx', pptx: 'pptx', xlsx: 'xlsx', epub: 'epub' }[state.kind] || 'pdf';
        var tgt = $('dtTgt') ? $('dtTgt').value : 'xx';
        if (window.__outputName) {
            return window.__outputName.join([window.__outputName.sanitize(stem), tgt], ext);
        }
        return stem + '-' + tgt + '.' + ext;
    }

    // ── view ─────────────────────────────────────────────────────────────

    function show(id) {
        ['dtUploadState', 'dtWork', 'dtResult'].forEach(function (x) {
            var el = $(x);
            if (el) el.hidden = (x !== id);
        });
    }

    function setProgress(label, ratio) {
        var l = $('dtPhase'); if (l) l.textContent = label;
        var b = $('dtBar');
        if (b) {
            // aria-valuenow стоит на дорожке (role=progressbar): его читает
            // экранный диктор и по нему же телеметрия меряет «полоса стояла»
            // (prog_still_s) — до 13.10.2026 эту полосу замер не видел вовсе.
            var track = b.parentNode;
            if (ratio == null) {
                b.classList.add('dt-indet');
                if (track) track.removeAttribute('aria-valuenow');
            } else {
                var pct = Math.max(0, Math.min(100, Math.round(ratio * 100)));
                b.classList.remove('dt-indet');
                b.style.width = pct + '%';
                if (track) track.setAttribute('aria-valuenow', String(pct));
            }
        }
    }

    function renderDisclosures(meta) {
        var box = $('dtNotes');
        if (!box) return;
        var lines = [];
        if (meta.flattened) {
            lines.push(t('note_flattened', 'Абзацев с курсивом/жирным внутри предложения: :n — выделение внутри них не сохранится')
                .replace(':n', meta.flattened));
        }
        if (meta.scanned && meta.scanned.length) {
            lines.push(t('note_scanned', 'Страниц без текстового слоя: :n — они распознаны')
                .replace(':n', meta.scanned.length));
        }
        if (meta.skewed) {
            lines.push(t('note_skewed', 'Повёрнутых надписей: :n — оставлены как есть')
                .replace(':n', meta.skewed));
        }
        if (meta.spreadsheet) {
            // Единственное раскрытие, которое принадлежит таблицам и ничему
            // больше: формулы не переводятся (переведённая СУММА — сломанная
            // СУММА), а формула, которая ИЩЕТ текст, после перевода подписи
            // его не найдёт. Обе половины верны одновременно, и молчать о
            // второй хуже, чем о ней сказать.
            lines.push(t('note_formulas', ''));
        }
        box.innerHTML = '';
        lines.forEach(function (s) {
            var p = document.createElement('p');
            p.className = 'dt-note';
            p.textContent = s;
            box.appendChild(p);
        });
        box.hidden = !lines.length;
    }

    var _rows = [];
    function renderPairs() {
        var host = $('dtPairs');
        if (!host) return;
        host.innerHTML = '';
        _rows = [];
        var frag = document.createDocumentFragment();
        state.units.forEach(function (u) {
            var row = document.createElement('div');
            row.className = 'dt-row';

            var a = document.createElement('div');
            a.className = 'dt-src';
            a.textContent = u.text;

            var b = document.createElement('div');
            b.className = 'dt-dst';
            b.contentEditable = 'true';
            b.spellcheck = true;
            b.setAttribute('role', 'textbox');
            b.setAttribute('aria-label', t('a11y_edit', 'Перевод абзаца — можно исправить'));
            b.textContent = state.edited[u.id] !== undefined ? state.edited[u.id] : (state.translated[u.id] || '');
            if (isUntranslated(u.id)) {
                row.classList.add('dt-untr');
                a.setAttribute('data-untr', t('row_untranslated', 'не переведено'));
            }
            b.addEventListener('input', function () {
                state.edited[u.id] = b.textContent;
                // Абзац, переведённый рукой, больше не «не переведён».
                if (row.classList.contains('dt-untr')) {
                    row.classList.remove('dt-untr');
                    a.removeAttribute('data-untr');
                    renderFailed();
                }
                markEdited();
            });
            row.appendChild(a);
            row.appendChild(b);
            frag.appendChild(row);
            _rows.push({ el: row, dst: b, src: u.text.toLowerCase() });
        });
        host.appendChild(frag);
        // Новая таблица — новый поиск: оставленная строка фильтра спрятала бы
        // большинство абзацев следующего документа, и это выглядело бы как
        // «перевелась только часть».
        var find = $('dtFind');
        if (find) find.value = '';
        applyFilter('');
    }

    /**
     * Поиск по паре «оригинал — перевод».
     *
     * Договор — это 200–600 абзацев, и человек, пришедший поправить одно
     * слово, не должен листать их все. Ищется И по исходнику, И по переводу:
     * термин знают на одном из двух языков, а на каком — заранее неизвестно.
     */
    function applyFilter(q) {
        q = String(q || '').trim().toLowerCase();
        var found = 0;
        _rows.forEach(function (r) {
            var hit = !q || r.src.indexOf(q) >= 0
                || String(r.dst.textContent || '').toLowerCase().indexOf(q) >= 0;
            r.el.hidden = !hit;
            r.el.classList.toggle('dt-hit', !!q && hit);
            if (hit) found++;
        });
        var badge = $('dtFound');
        if (badge) {
            badge.hidden = !q;
            badge.textContent = t('find_count', ':n из :total')
                .split(':n').join(fmtN(found)).split(':total').join(fmtN(_rows.length));
        }
        var none = $('dtNoHits');
        if (none) none.hidden = !(q && found === 0);
        return found;
    }

    var _edited = false;
    function markEdited() {
        if (_edited) return;
        _edited = true;
        ae('edit_translation', {});
        var b = $('dtDownload');
        if (b) b.classList.add('dt-restale');
    }

    // ── intake ───────────────────────────────────────────────────────────

    /**
     * The free day's cap is charged per FILE and only once a document is
     * actually handed over — and only for the STANDARD lane. Until 09.10.2026
     * it was taken before the file was even read, for every mode: a visitor who
     * had used up the day could not even pay tokens for a precise translation
     * of the next document (78 sessions in 30 days met that wall and left).
     */
    async function takeTicket(file) {
        if (!window.__toolLimit) return true;
        state.limitTicket = await window.__toolLimit.begin(slug, [file.name + ':' + file.size]);
        return !!state.limitTicket;
    }

    /**
     * Язык, который тул САМ вписал в «Язык документа», принадлежит тому
     * документу, по которому угадан. До 14.10.2026 он оставался в списке, и
     * следующий документ уже не определялся («не авто» — значит, человек
     * выбрал): после английского файла русский переводился «с английского»
     * либо упирался в «язык документа совпадает с языком перевода». Выбор,
     * сделанный человеком (список или «поменять местами»), остаётся.
     */
    var _srcGuessed = false;
    function forgetGuessedSource() {
        var sel = $('dtSrc');
        if (_srcGuessed && sel) {
            sel.value = 'auto';
            Array.prototype.slice.call(sel.querySelectorAll('option[data-guessed]')).forEach(function (o) { o.remove(); });
            sel.dispatchEvent(new Event('dt:src-reset'));
        }
        _srcGuessed = false;
    }

    /**
     * Язык документа — у Google, по образцу всего документа
     * (`TranslatorEngine.identifyLanguage`), а не по письменности.
     *
     * ⚠️⚠️ До 23.10.2026 здесь стоял `detectLanguage()` — определитель
     * ПИСЬМЕННОСТИ, который любую латиницу называет английским. Так каждый
     * немецкий, французский, испанский документ переводился «с английского»:
     * обращение 22.10 («Очень кривой перевод с немецкого на русский», .xlsx) —
     * «Kursbeschreibung» → «Курсбешрайбунг», «Teilnehmer» → «Тейлнемер», каждая
     * пятая немецкая строка возвращалась непереведённой. За 20 дней тул вписал
     * «English» 2559 раз — сколько из них было не английским, телеметрия не
     * знала. Любая кириллица была «русским»: украинский документ на /ru упирался
     * в «язык совпадает с языком перевода». Замеры и выбор — в комментарии к
     * identifyLanguage и в docs/why/primitives/translate-texts.md.
     *
     * Не узнали (Google не ответил) — остаётся «авто», а не догадка: Google
     * тогда определяет язык сам, по каждому абзацу. Язык, которого нет в
     * списке (чешский, шведский, румынский…), всё равно называется переводчику:
     * читать .docx и .xlsx умеем на любом, список ограничен распознаванием сканов.
     */
    async function guessSource() {
        var TE = window.TranslatorEngine, sel = $('dtSrc');
        if (!TE || !sel) return;
        var info = null;
        try {
            if (typeof TE.identifyLanguage === 'function') {
                info = await TE.identifyLanguage(languageUnits(state.units), { target: val('dtTgt') });
            }
        } catch (e) { info = null; }
        if (!info || info.ambiguous || !info.lang) {
            ae('lang_unknown', { script: (info && info.script) || '' });
            return;
        }
        var opt = sourceOption(sel, info.lang);
        if (!opt) { ae('lang_unknown', { script: info.script || '', got: info.lang }); return; }
        sel.value = opt.value;
        _srcGuessed = true;
        var p = { lang: opt.value, via: info.source || '' };
        if (info.share) p.share = info.share;
        if (opt.hasAttribute('data-guessed')) p.listed = 0;
        ae('lang_detected', p);
    }

    /** Пункт «Язык документа» для кода: свой, по базовому коду (zh-CN → zh) или новый. */
    function sourceOption(sel, code) {
        var base = String(code).split('-')[0];
        var opt = sel.querySelector('option[value="' + code + '"]') || sel.querySelector('option[value="' + base + '"]');
        if (opt) return opt;
        if (!/^[a-z]{2,3}$/.test(base)) return null;
        // Название — на самом языке, как у остальных пунктов списка.
        var name = base;
        try { name = new Intl.DisplayNames([base], { type: 'language' }).of(base) || base; } catch (e) { /* старый браузер */ }
        name = name.charAt(0).toUpperCase() + name.slice(1);
        opt = new Option(name, base);
        opt.setAttribute('data-guessed', '');
        sel.appendChild(opt);
        return opt;
    }

    async function accept(file, opts) {
        if (state.busy) return;
        opts = opts || {};
        state.busy = true;
        state.file = file;
        if (!opts.resume) forgetGuessedSource();
        state.translated = {}; state.edited = {}; _edited = false;
        state.failed = {}; state.run = null;
        state.delivered = false;
        state.provider = null;

        funnel('file_picked', { bytes: file.size });
        show('dtWork');
        setProgress(t('phase_read', 'Чтение документа'), null);

        try {
            state.doc = await readDocument(file);
            state.units = state.doc.units;
            state.meta = state.doc.meta;
            funnel('read', { kind: state.kind, paragraphs: state.meta.paragraphs, chars: state.meta.chars });

            if (!state.units.length) {
                toast(t('err_empty', 'В документе не нашлось текста для перевода'), 'warning');
                abortTicket();
                show('dtUploadState');
                return;
            }

            // Source language, from the document itself. Asking the visitor to
            // pick it is asking them to know something the text already says.
            if (window.TranslatorEngine && $('dtSrc') && $('dtSrc').value === 'auto') {
                await guessSource();
            }

            // Документ уже на языке перевода: перевод «в себя» — пустая работа,
            // которую человек принял бы за готовый результат. Файл прочитан —
            // спрашиваем язык и продолжаем без повторной загрузки.
            if (!(await ensureDifferentTarget())) { abortTicket(); show('dtUploadState'); return; }
            if (!(await pdfCanWriteTarget())) { abortTicket(); show('dtUploadState'); return; }

            // Вернулись из кассы к документу, у которого уже был обычный перевод:
            // перевод возвращается как был (обычный лейн не гоняется заново), и
            // сразу — предложение точного с ценой.
            var back = opts.resume;
            if (back && back.translated && back.sig === unitsSig() && (await takeTicket(file))) {
                state.translated = back.translated || {};
                state.edited = back.edited || {};
                state.provider = 'standard';
                renderNotes();
                renderPairs();
                fillSummary({ unique: buildJobs().length, saved: state.units.length - buildJobs().length, failed: 0 });
                show('dtResult');
                state.busy = false;
                translateAgainPrecisely();
                return;
            }

            var mode = quality();
            var tooLongNote = '';
            if (mode === 'precise') {
                var plan = precisePlan(buildJobs(), currentGlossary());
                if (plan.tooLong) {
                    // Решено ДО цены и с числами, и сказано в результате, а не
                    // тостом: документ уходит обычному лейну, и причина должна
                    // остаться рядом с переводом.
                    tooLongNote = t('precise_too_long', '').split(':chars').join(fmtN(plan.chars)).split(':max').join(fmtN(LANE.maxChars * (LANE.maxParts || 8)));
                    ae('precise_refused', { reason: 'too_long', chars: plan.chars, units: plan.rest.length, parts: plan.nParts });
                }
                var pick = plan.send.length ? await preciseOffer(plan) : 'standard';
                if (pick === 'cancel') { show('dtUploadState'); return; }
                if (pick === 'standard') mode = 'standard';
            }
            if (mode === 'standard' && !(await takeTicket(file))) {
                // Обычных переводов на сегодня больше нет — стену показал
                // примитив лимита. Вместо тупика: этот документ можно перевести
                // точно, за токены.
                var plan2 = preciseOpen() ? precisePlan(buildJobs(), currentGlossary()) : null;
                if (!plan2 || !plan2.send.length || (await preciseOffer(plan2, { capped: true })) !== 'go') {
                    show('dtUploadState');
                    return;
                }
                mode = 'precise';
            }
            var res = await translateAll(mode);
            // Не перевелось НИЧЕГО — это не результат. До 13.10.2026 такой
            // документ показывался как переведённый (колонка «перевод» из
            // оригиналов и тост), а его скачивание списывало суточный файл:
            // 17 прогонов за 30 дней целиком, ещё 100 — больше чем наполовину.
            // Теперь — повторить либо перевести точно, с ценой; отмена
            // возвращает к выбору файла и суточный файл не тратит.
            while (res.unique > 0 && res.failed >= res.unique) {
                ae('std_all_failed', Object.assign({ unique: res.unique }, state.run || {}));
                var plan3 = preciseOpen() ? precisePlan(buildJobs(), currentGlossary()) : null;
                var pick3 = await preciseOffer(plan3, { failed: true });
                if (pick3 === 'cancel') { abortTicket(); show('dtUploadState'); return; }
                // Точный оплачивается токенами — суточный файл обычного лейна
                // за него не списывается.
                if (pick3 === 'go') abortTicket();
                res = await translateAll(pick3 === 'go' ? 'precise' : 'standard');
            }
            if (tooLongNote) state.preciseNotes.push(tooLongNote);
            funnel('translated', Object.assign({
                unique: res.unique, saved: res.saved, failed: res.failed,
                provider: state.provider || 'unknown',
                mode: state.provider === 'precise' ? 'precise' : 'standard',
            }, state.run || {}));
            if (res.failed) {
                toast(t('err_partial', 'Часть абзацев перевести не удалось — они остались как были'), 'warning');
            }

            renderNotes();
            renderPairs();
            fillSummary(res);
            show('dtResult');
        } catch (e) {
            abortTicket();
            var msg = String((e && e.message) || e);
            if (msg.indexOf('pdf_password') === 0 || msg.indexOf('pdf_locked') === 0) refuseInZone(t('err_pdf_locked', 'Этот PDF защищён паролем, и без пароля перевести его нельзя.'));
            else if (msg.indexOf('unsupported') >= 0) toast(t('err_format', 'Поддерживаются DOCX, PDF и EPUB'), 'error');
            else if (msg.indexOf('engine_missing') >= 0) toast(t('err_engine', 'Переводчик не загрузился'), 'error');
            else if (e && e.name === 'AbortError') toast(t('cancelled', 'Отменено'), 'info');
            else toast(t('err_generic', 'Не удалось обработать документ'), 'error');
            if (window.__aeDiagnostic) window.__aeDiagnostic({ issue: 'read_or_translate_failed', msg: msg.slice(0, 160) });
            show('dtUploadState');
        } finally {
            state.busy = false;
        }
    }

    /**
     * Отказ, который должен остаться на экране: тост с «снимите защиту
     * инструментом …» исчезнет раньше, чем его дочитают. Зона загрузки умеет
     * показать отказ в себе и снова открыться для выбора.
     */
    function refuseInZone(message) {
        var up = $('dtUpload');
        try {
            if (up && typeof up.__uploaderRestore === 'function') up.__uploaderRestore(true);
            if (up && typeof up.__uploaderReject === 'function') {
                var reasons = (window.ToolErrors && window.ToolErrors.REASONS) || {};
                up.__uploaderReject(message, reasons.INVALID_FORMAT || reasons.WRONG_FORMAT || 'invalid_format');
                return;
            }
        } catch (e) { /* ниже — тост */ }
        toast(message, 'error');
    }

    /**
     * Образец для определения языка — по ВСЕМУ документу, а не первые сорок
     * абзацев: первая страница — это титул, выходные данные и «скачано с…», и
     * язык документа они называют хуже всего. Абзац даёт не больше 200 знаков,
     * чтобы один длинный не занял весь образец (движок смотрит 4000 знаков).
     */
    function languageUnits(units) {
        var take = Math.min(units.length, 60), step = units.length / take;
        var out = [], chars = 0;
        for (var i = 0; i < take && chars < 4000; i++) {
            var s = String(units[Math.floor(i * step)].text || '').slice(0, 200);
            out.push(s);
            chars += s.length + 1;
        }
        // Абзацы ПО ОТДЕЛЬНОСТИ: в смешанном документе (словарик «немецкий —
        // русский») целиком он читается как русский, и только по абзацам видно
        // второй язык, с которого и нужно переводить.
        return out;
    }

    /**
     * A PDF is written with the faces we ship, and a target script none of them
     * covers cannot be written at all (Hindi, Thai and Hebrew on 09.10.2026 —
     * offered in the menu, refused only at «Скачать», after the whole
     * translation, as «Не удалось собрать документ»). Say it BEFORE the work.
     * The sample is the option's own label: the menu names every language in
     * its own script, so no second list of languages has to be kept here.
     */
    async function pdfCanWriteTarget() {
        var TF = window.PdfTextFont, sel = $('dtTgt');
        if (state.kind !== 'pdf' || !TF || !sel || !sel.selectedOptions[0]) return true;
        var name = sel.selectedOptions[0].textContent.trim();
        try {
            await TF.load();
            if (TF.needsCjk(name)) await TF.loadCjk();
            if (TF.pick(name)) return true;
        } catch (e) {
            return true;   // coverage unknown — the build decides, as before
        }
        toast(t('err_no_font', 'Собрать PDF на языке «:lang» пока не можем: для его письменности у нас нет шрифта. Выберите другой язык перевода.').split(':lang').join(name), 'error');
        ae('pdf_no_font', { lang: sel.value });
        return false;
    }

    /** true — можно переводить (язык при надобности переспрошен); false — отменено. */
    async function ensureDifferentTarget() {
        var srcSel = $('dtSrc'), tgtSel = $('dtTgt');
        var box = $('dtSame'), pick = $('dtSameTgt'), go = $('dtSameGo');
        if (!srcSel || !tgtSel || !box || !pick || !go) return true;
        if (srcSel.value === 'auto' || srcSel.value !== tgtSel.value) return true;
        var name = srcSel.selectedOptions[0] ? srcSel.selectedOptions[0].textContent.trim() : srcSel.value;
        $('dtSameMsg').textContent = t('same_lang', 'Язык документа совпадает с языком перевода (:lang). На какой язык перевести?').split(':lang').join(name);
        pick.innerHTML = '';
        Array.prototype.forEach.call(tgtSel.options, function (o) {
            if (o.value !== srcSel.value) pick.appendChild(new Option(o.textContent, o.value));
        });
        // Английский первым, если документ не на нём: самая частая цель.
        if (srcSel.value !== 'en' && pick.querySelector('option[value="en"]')) pick.value = 'en';
        var phase = $('dtPhase'), track = document.querySelector('#dtWork .dt-track');
        box.hidden = false;
        if (phase) phase.hidden = true;
        if (track) track.hidden = true;
        ae('same_language_asked', { lang: srcSel.value });
        var chosen = await new Promise(function (resolve) {
            var cancel = $('dtCancel');
            function done(v) {
                go.removeEventListener('click', onGo);
                if (cancel) cancel.removeEventListener('click', onCancel);
                resolve(v);
            }
            function onGo() { done(pick.value); }
            function onCancel() { done(null); }
            go.addEventListener('click', onGo);
            if (cancel) cancel.addEventListener('click', onCancel);
        });
        box.hidden = true;
        if (phase) phase.hidden = false;
        if (track) track.hidden = false;
        if (!chosen) { ae('same_language_cancel', {}); return false; }
        tgtSel.value = chosen;
        tgtSel.dispatchEvent(new Event('change', { bubbles: true }));
        ae('same_language_picked', { from: srcSel.value, to: chosen });
        return true;
    }

    /**
     * Чем считается документ — зависит от документа. Колода меряется слайдами,
     * книга страницами, таблица листами; «Страниц: 12» у презентации было бы
     * числом, которого в ней нет.
     */
    function pageWording() {
        if (state.kind === 'pptx') return { sum: 'sum_slides', stat: 'stat_slides' };
        if (state.kind === 'xlsx') return { sum: 'sum_sheets', stat: 'stat_sheets' };
        return { sum: 'sum_pages', stat: 'stat_pages' };
    }

    function statTile(label, value) {
        var d = document.createElement('div');
        d.className = 'tc-stat';
        var l = document.createElement('div');
        l.className = 'tc-stat-l';
        l.textContent = label;
        var v = document.createElement('div');
        v.className = 'tc-stat-v';
        v.textContent = value;
        d.appendChild(l);
        d.appendChild(v);
        return d;
    }

    /** «Deutsch → Русский» по выбранным пунктам; язык не узнан — пусто. */
    function directionLabel() {
        var s = $('dtSrc'), g = $('dtTgt');
        if (!s || !g || s.value === 'auto' || !s.selectedOptions[0] || !g.selectedOptions[0]) return '';
        // Названия — изолированы (у каждого своё направление письма); на
        // странице справа налево порядок чтения тот же, поэтому стрелка
        // смотрит влево, к языку перевода.
        var rtl = document.documentElement.getAttribute('dir') === 'rtl';
        var iso = function (x) { return '⁨' + x + '⁩'; };
        return iso(s.selectedOptions[0].textContent.trim()) + (rtl ? ' ← ' : ' → ') + iso(g.selectedOptions[0].textContent.trim());
    }

    function fillSummary(res) {
        var w = pageWording();

        // Плитки — то, на что смотрят; строка ниже — то, что читает экранный
        // диктор одним предложением вместо трёх отдельных чисел.
        var tiles = $('dtStats');
        if (tiles) {
            tiles.innerHTML = '';
            // С какого языка переводили — на виду: неверно названный язык
            // документа даёт «кривой перевод», и без этой плитки причину не
            // увидеть (обращение 22.10.2026).
            var dir = directionLabel();
            if (dir) tiles.appendChild(statTile(t('stat_direction', 'Перевод'), dir));
            tiles.appendChild(statTile(t('stat_paragraphs', 'Абзацев'), fmtN(state.meta.paragraphs)));
            if (state.meta.pages) tiles.appendChild(statTile(t(w.stat, 'Страниц'), fmtN(state.meta.pages)));
            if (res.saved > 0) tiles.appendChild(statTile(t('stat_memory', 'Повторов'), fmtN(res.saved)));
        }

        var el = $('dtSummary');
        if (!el) return;
        var bits = [];
        bits.push(t('sum_paragraphs', 'Абзацев: :n').replace(':n', state.meta.paragraphs));
        if (state.meta.pages) bits.push(t(w.sum, 'Страниц: :n').replace(':n', state.meta.pages));
        if (res.saved > 0) bits.push(t('sum_memory', 'Повторов не переводили: :n').replace(':n', res.saved));
        el.textContent = bits.join(' · ');
        var prov = $('dtProvider');
        if (prov) {
            var precise = state.provider === 'precise';
            prov.hidden = !precise && state.provider !== 'chrome';
            if (precise) prov.textContent = t('precise_done', 'Точный перевод: документ переведён целиком');
            else if (state.provider === 'chrome') prov.textContent = t('on_device', 'Перевод выполнен на устройстве');
        }
    }

    /**
     * `begin()` hands back a TOKEN and the slot is settled ON IT — the module
     * has no `commit(ticket)` of its own. Calling one spends nothing, throws a
     * TypeError, and the visitor sees "could not build the document" on top of
     * a document that downloaded perfectly. Both halves of that were live until
     * the end-to-end run caught them.
     */
    function abortTicket() {
        if (state.limitTicket) {
            try { state.limitTicket.abort(); } catch (e) {}
            state.limitTicket = null;
        }
    }

    async function download() {
        var btn = $('dtDownload');
        if (btn) btn.disabled = true;
        var blob = null;
        try {
            setProgress(t('phase_build', 'Сборка документа'), null);
            show('dtWork');
            blob = await buildOutput();
            // ⚠️ The verdict is the RESOLVED VALUE. __downloadFile refuses by
            // RETURNING false (over the relay cap, a second delivery in one
            // gesture, unreadable bytes) and practically never throws — so this
            // try/catch used to record every refusal as a delivery.
            var okDl = window.__downloadFile ? await window.__downloadFile(blob, outName()) : false;
            state.delivered = okDl !== false;
        } catch (e) {
            var tgtOpt = $('dtTgt') && $('dtTgt').selectedOptions[0];
            if (e && e.message === 'no_face_for_target_language' && tgtOpt) {
                toast(t('err_no_font', 'Собрать PDF на языке «:lang» пока не можем: для его письменности у нас нет шрифта. Выберите другой язык перевода.').split(':lang').join(tgtOpt.textContent.trim()), 'error');
            } else {
                toast(t('err_export', 'Не удалось собрать документ'), 'error');
            }
            if (window.__aeDiagnostic) {
                window.__aeDiagnostic({ issue: 'build_failed', msg: String((e && e.message) || e).slice(0, 160) });
            }
            show('dtResult');
            if (btn) { btn.disabled = false; btn.classList.remove('dt-restale'); }
            return;
        }

        // Bookkeeping AFTER delivery, in its own try: the file is already in the
        // visitor's hands, so a failure here is ours to log and never theirs to
        // read as "it did not work".
        try {
            if (state.limitTicket) { state.limitTicket.commit(); state.limitTicket = null; }
            funnel('download', {
                kind: state.kind, edited: _edited ? 1 : 0,
                bilingual: ($('dtBilingual') && $('dtBilingual').checked) ? 1 : 0,
                shrunk: state.stats ? state.stats.shrunk : null,
                chain_kept: state.stats && state.stats.erased ? state.stats.erased.chainKept : null,
                // Characters no shipped face draws (09.10.2026): rewritten by
                // NFKC, left out, and paragraphs kept in the original.
                glyph_norm: state.stats && state.stats.glyphs ? state.stats.glyphs.normalized : null,
                glyph_drop: state.stats && state.stats.glyphs ? state.stats.glyphs.dropped : null,
                glyph_kept: state.stats && state.stats.glyphs ? state.stats.glyphs.kept : null,
                glyph_chars: state.stats && state.stats.glyphs ? state.stats.glyphs.chars : null,
            });
            if (window.__aeToolComplete) {
                window.__aeToolComplete({ kind: state.kind, paragraphs: state.meta.paragraphs });
            }
        } catch (e) {
            if (window.__aeDiagnostic) {
                window.__aeDiagnostic({ issue: 'post_delivery_failed', msg: String((e && e.message) || e).slice(0, 160) });
            }
        }
        show('dtResult');
        if (btn) { btn.disabled = false; btn.classList.remove('dt-restale'); }
    }

    function reset() {
        state.doc = null; state.units = []; state.translated = {}; state.edited = {};
        state.failed = {}; state.run = null;
        state.meta = null; state.stats = null; _edited = false;
        abortTicket();
        forgetGuessedSource();
        show('dtUploadState');
    }

    // ── wiring ───────────────────────────────────────────────────────────

    function init() {
        var up = $('dtUpload');
        if (up) {
            // The primitive calls back with (File, detail) — not with an event.
            var onFile = function (file, detail) {
                var d = detail || {};
                var f = (d.files && d.files[0]) || file;
                if (f) accept(f);
            };
            if (typeof window.__bindUploaderFile === 'function') window.__bindUploaderFile(up, onFile);
            else {
                up.addEventListener('tool-uploader:file', function (ev) {
                    var d = (ev && ev.detail) || {};
                    onFile(d.file || (d.files && d.files[0]) || null, d);
                });
            }
            up.addEventListener('tool-uploader:clear', reset);
        }

        var dl = $('dtDownload');
        if (dl) dl.addEventListener('click', download);
        var again = $('dtAgain');
        if (again) again.addEventListener('click', reset);
        var retry = $('dtRetry');
        if (retry) retry.addEventListener('click', retryFailed);
        if (LANE) {
            document.querySelectorAll('input[name="dtQuality"]').forEach(function (r) {
                r.addEventListener('change', function () {
                    if (window.__toolSettings) window.__toolSettings.save(slug, 'quality', r.value);
                    // Цена понадобится сразу после чтения файла — взять её заранее.
                    if (r.value === 'precise' && r.checked) preciseInfo();
                    ae('quality_pick', { q: r.value });
                });
            });
            var pb = $('dtPrecise');
            if (pb) pb.addEventListener('click', translateAgainPrecisely);
            // План посетителя приходит из session-bootstrap ПОСЛЕ старта скрипта.
            var syncQ = function () { applySavedQuality(); };
            syncQ();
            window.addEventListener('tier-bootstrap:ready', syncQ);
            document.addEventListener('tier-bootstrap:ready', syncQ);
        }
        var cancel = $('dtCancel');
        if (cancel) cancel.addEventListener('click', function () {
            if (state.abort) state.abort.abort();
        });

        // ── поменять языки местами ───────────────────────────────────────
        // Пока язык документа «определить автоматически», менять нечего:
        // кнопка ВЫКЛЮЧЕНА, а не молча бездействует — выключенный орган
        // объясняет себя, бездействующий выглядит поломкой.
        var swap = $('dtSwap'), src = $('dtSrc'), tgt = $('dtTgt');
        function syncSwap() {
            if (swap && src) swap.disabled = src.value === 'auto';
        }
        if (swap && src && tgt) {
            swap.addEventListener('click', function () {
                if (src.value === 'auto') return;
                var a = src.value, b = tgt.value;
                // Язык документа обязан остаться среди тех, что есть у цели:
                // списки совпадают, но проверка стоит копейку и переживёт их
                // расхождение.
                if (!src.querySelector('option[value="' + b + '"]')) return;
                src.value = b;
                tgt.value = a;
                _srcGuessed = false;
                tgt.dispatchEvent(new Event('change', { bubbles: true }));
                ae('lang_swap', { from: a, to: b });
            });
            // `change` приходит только от человека: значение, вписанное кодом,
            // его не шлёт. Значит, это выбор — и он переживает смену документа.
            src.addEventListener('change', function () { _srcGuessed = false; syncSwap(); });
            src.addEventListener('dt:src-reset', syncSwap);
            syncSwap();
        }

        // ── поиск по таблице правки ──────────────────────────────────────
        var find = $('dtFind');
        if (find) {
            var fTimer = null;
            find.addEventListener('input', function () {
                clearTimeout(fTimer);
                fTimer = setTimeout(function () {
                    var n = applyFilter(find.value);
                    if (find.value.trim()) ae('pairs_search', { hits: n, of: _rows.length });
                }, 140);
            });
        }

        ['dtTgt', 'dtGlossary', 'dtBilingual', 'dtFormality', 'dtDomain'].forEach(function (id) {
            var el = $(id);
            if (el && window.__toolSettings) {
                window.__toolSettings.bind(slug, el, id, el.type === 'checkbox' ? el.checked : el.value);
            }
        });

        // Документ, оставленный ждать оплаты, — предложить вернуть его.
        if (LANE) offerResume();

        // A visitor who leaves with an unsaved translation has not been served,
        // and the funnel must not read that as a finished job.
        window.addEventListener('pagehide', function () {
            if (state.units.length && !state.delivered) ae('left_without_download', { kind: state.kind });
        });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
